import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
var fixFactor = Math.sqrt(2);
export var SquareDrawer = /*#__PURE__*/function () {
  function SquareDrawer() {
    _classCallCheck(this, SquareDrawer);
  }
  _createClass(SquareDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 4;
    }
  }, {
    key: "draw",
    value: function draw(context, particle, radius) {
      context.rect(-radius / fixFactor, -radius / fixFactor, radius * 2 / fixFactor, radius * 2 / fixFactor);
    }
  }]);
  return SquareDrawer;
}();